'use client';
import ButtonClose from '@components/button-close/ButtonClose';
import {
  handleChangeFormName,
  handleChangeHiddenMessageFormCallBack,
  handleFavoriteInputForm,
  handleOpenModelForm,
  handleOpenTradeInForm,
  modelFormSelector,
} from '@lib/store/slices/ComponentsSlice';
import { activeBulkSelector, setActiveBulk } from '@lib/store/slices/VisualBulkSlice';
import { animated, useSpring } from '@react-spring/web';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormCall from '../form-call/FormCall';

import style from './FormModal.module.scss';

function FormModal() {
  const dispatch = useDispatch();
  const formRef = useRef();
  const openModelForm = useSelector(modelFormSelector);
  const activeBulk = useSelector(activeBulkSelector);

  useEffect(() => {
    if (openModelForm) {
      setTimeout(() => {
        setToggle(false);
      }, 400);
    }
  }, [openModelForm]);

  const [toggle, setToggle] = useState(true);

  const opacityStyle = useSpring({
    config: { duration: 600 },
    opacity: toggle ? 0 : 1,
    x: toggle ? -1000 : 0,
    delay: 0,
    loop: false,
  });

  const handleCloseFormModel = () => {
    setToggle(true);
    setTimeout(() => {
      dispatch(handleOpenModelForm(false));
      dispatch(handleFavoriteInputForm(false));
      dispatch(handleOpenTradeInForm(false));
      dispatch(handleChangeFormName(null));
      dispatch(handleChangeHiddenMessageFormCallBack(null));
      if (activeBulk !== null) {
        dispatch(setActiveBulk(null));
      }
    }, 500);
  };

  return (
    <>
      {openModelForm && (
        <div className={style.formModal}>
          <div className={style.formModalBack} />
          <animated.div style={opacityStyle} className={style.formModalContainer} ref={formRef}>
            <ButtonClose id='close_white' className={style.formModalBtnClose} handleFuction={handleCloseFormModel} />
            <FormCall handleCloseFormModel={handleCloseFormModel} classNameTitle={style.formModalTitle} />
          </animated.div>
        </div>
      )}
    </>
  );
}

export default FormModal;
